module.exports = __webpack_public_path__ + "img/9788952235695.652a3bd8.jpg";